var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostIconLocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 24.0008V20.333L19.8598 4.47308C19.9302 4.40279 20.0255 4.36328 20.125 4.36328C20.2245 4.36328 20.3198 4.40279 20.3902 4.47308L23.5277 7.61072C23.5982 7.68121 23.6377 7.77664 23.6377 7.87584C23.6377 7.97502 23.5982 8.07043 23.5278 8.14092C23.5278 8.14093 23.5278 8.14095 23.5277 8.14097L7.66789 24.0008H4Z",
    stroke: "#E5E5EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4786 5.6219L20.125 5.26831L19.7714 5.62189L4.89645 20.4969L4.75 20.6433V20.8505V22.7506V23.2506H5.25H7.14996H7.35707L7.50352 23.1041L22.3785 8.22914L22.7321 7.87561L22.3785 7.52205L20.4786 5.6219ZM20.125 4.36328C20.2219 4.36328 20.317 4.39979 20.3904 4.47304L23.5278 7.61051L23.5279 7.61058C23.6739 7.75655 23.6739 7.99463 23.5279 8.1406L23.5278 8.14066L7.66789 24.0006H4V20.3327L19.8599 4.47277L19.8601 4.4726C19.9326 4.40003 20.0278 4.36328 20.125 4.36328Z",
    fill: "black",
    stroke: "#E5E5EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 23.625H24.5",
    stroke: "#E5E5EC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 7L21 11.375",
    stroke: "#E5E5EC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostIconLocked);
export default __webpack_public_path__ + "static/media/post_Icon_locked.27ebd19b2590d40873557a6da61be673.svg";
export { ForwardRef as ReactComponent };